export default __webpack_public_path__ + "static/media/Evapotranspiration.27ad4eb8.webp";